var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2101_167)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 23,
    r: 22,
    fill: "#407EC1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8099 19.6955H32.1936C32.1495 19.6957 32.1059 19.6858 32.0661 19.6666C32.0263 19.6474 31.9914 19.6194 31.964 19.5848C31.9367 19.5501 31.9175 19.5097 31.9081 19.4666C31.8986 19.4234 31.8991 19.3787 31.9094 19.3357C32.1749 18.2168 32.2874 17.0671 32.244 15.918C32.2657 15.2474 32.2537 14.5762 32.208 13.9069C32.1703 13.2302 31.9448 12.5774 31.5569 12.0217C31.3414 11.7206 31.0605 11.4722 30.7352 11.2952C30.4099 11.1182 30.0488 11.0173 29.6789 11C27.9412 11 27.6678 12.7053 27.5203 14.0868C27.3296 15.6985 27.2541 17.3642 26.5417 18.8465C26.0453 19.8862 25.3365 20.7784 24.2285 21.2173C23.4645 21.5562 22.6676 21.8154 21.8504 21.9908C21.7825 22.0035 21.7211 22.0396 21.6771 22.0928C21.633 22.1461 21.6091 22.2131 21.6094 22.2822V33.5393C21.6094 33.6185 21.6408 33.6944 21.6968 33.7504C21.7528 33.8064 21.8288 33.8379 21.908 33.8379H25.0199C25.0669 33.8381 25.1131 33.8494 25.1549 33.8706C25.1967 33.8918 25.2331 33.9225 25.261 33.9602C25.5739 34.3818 25.9813 34.7242 26.4505 34.9597C26.9198 35.1953 27.4378 35.3175 27.9628 35.3165H37.7232C38.4096 35.3146 39.0674 35.0411 39.5528 34.5557C40.0381 34.0704 40.3117 33.4126 40.3136 32.7262C40.3133 32.3696 40.2282 32.0181 40.0653 31.7009C40.0343 31.6411 40.0253 31.5724 40.0398 31.5067C40.0542 31.4409 40.0913 31.3824 40.1445 31.3411C40.6733 30.9202 41.0115 29.9596 41.0115 29.2329V28.9379C41.0129 28.5815 40.929 28.2299 40.7669 27.9125C40.7373 27.8525 40.729 27.7842 40.7434 27.7188C40.7577 27.6534 40.7939 27.5949 40.846 27.5528C41.1165 27.3374 41.3349 27.0639 41.485 26.7524C41.6351 26.441 41.7131 26.0997 41.713 25.754V25.459C41.7132 25.1027 41.6294 24.7514 41.4684 24.4336C41.4377 24.3741 41.4285 24.3059 41.4423 24.2403C41.4561 24.1748 41.4919 24.116 41.5439 24.0739C41.8157 23.8594 42.0352 23.5861 42.186 23.2745C42.3368 22.9629 42.415 22.6212 42.4146 22.275C42.4098 21.588 42.133 20.9309 41.6449 20.4474C41.1567 19.964 40.4969 19.6936 39.8099 19.6955Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0223 20.7139H14.9858C14.4413 20.7139 14 21.1552 14 21.6996V33.9964C14 34.5408 14.4413 34.9821 14.9858 34.9821H19.0223C19.5667 34.9821 20.0081 34.5408 20.0081 33.9964V21.6996C20.0081 21.1552 19.5667 20.7139 19.0223 20.7139Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2101_167",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2101_167"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2101_167",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.816b6f4b035196961a8df33fd75ec95a.svg";
export { ForwardRef as ReactComponent };